// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import FastClick from 'fastclick'
// import VueRouter from 'vue-router'
import App from './App'
import router from './router'
// import less from 'less'
import '../static/iconfont/iconfont.css';
import './css/app.css';
import './css/public.css';
// import './css/public.less';
import func from '@/utils/func';
import api from '@/utils/api';
import customer from '@/customer';
import infiniteScroll from 'vue-infinite-scroll';
// Vue.use(less);
Vue.use(infiniteScroll);
Vue.prototype.$api = api;
Vue.prototype.$func = func;
Vue.prototype.$customer = customer;
Vue.prototype.$customerAsset = function (name, fallback) {
  return (customer.assets && customer.assets[name]) || fallback || ''
}
FastClick.attach(document.body)
document.body.className = (document.body.className ? document.body.className + ' ' : '') + 'theme-' + customer.theme + ' customer-' + customer.key
if (process.env.NODE_ENV === 'development') {
  const devCustomerKey = 'dev_customer'
  const devTokenKey = 'dev_token_' + customer.key
  const savedCustomer = func.getLocal(devCustomerKey)
  const testToken = process.env.TEST_TOKEN
  const localToken = func.getLocal('token')

  if (savedCustomer && savedCustomer !== customer.key) {
    window.localStorage.removeItem('token')
    window.localStorage.removeItem('grade')
    window.localStorage.removeItem('cid')
    window.localStorage.removeItem('store_list')
    window.localStorage.removeItem('node_v1')
  }

  if (testToken) {
    if (localToken !== testToken) {
      window.localStorage.removeItem('grade')
      window.localStorage.removeItem('cid')
      window.localStorage.removeItem('store_list')
      window.localStorage.removeItem('node_v1')
    }
    func.setLocal(devTokenKey, testToken)
    func.setLocal('token', testToken)
  } else if (!func.getLocal('token') && func.getLocal(devTokenKey)) {
    func.setLocal('token', func.getLocal(devTokenKey))
    window.localStorage.removeItem('grade')
    window.localStorage.removeItem('cid')
    window.localStorage.removeItem('store_list')
    window.localStorage.removeItem('node_v1')
  }

  func.setLocal(devCustomerKey, customer.key)
}
router.beforeEach((to,from,next)=>{
  if(to.meta.title){
    document.title = to.meta.title
  }
  next()
})
Vue.config.productionTip = true;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js